/**
 * @file GMOを扱うためのUtility関数群
 */

const apiKey = process.env.REACT_APP_GMO_API_KEY

function getGmoToken(body) {
  return new Promise((resolve, reject) => {
    window.Multipayment.init(apiKey)
    window.Multipayment.getToken(body, (result) => {
      if (result.resultCode !== '000') {
        const errorMessages = ['error', `resultCode: ${result.resultCode}`]
        reject(errorMessages)
      }

      resolve(result.tokenObject.token)
    })
  })
}

export { getGmoToken }
